import {useEffect, useState} from 'react'
import {postNombreMunicipio} from '../../actions/catalogos.actions'

interface PropiedadesNombreMunicipio {
  departamento: any
  municipio: any
}

export default function NombreMunicipio({departamento, municipio}: PropiedadesNombreMunicipio) {
  const [nombre, setNombre] = useState('')

  const codigoDepartamento = `${departamento ?? ''}`.trim()
  const codigoMunicipio = `${municipio ?? ''}`.trim()

  useEffect(() => {
    let vigente = true
    setNombre('')
    if (!codigoDepartamento || !codigoMunicipio) return
    postNombreMunicipio(codigoDepartamento, codigoMunicipio).then((res) => {
      if (vigente && res?.body?.valor) setNombre(`${res.body.valor}`)
    })
    return () => {
      vigente = false
    }
  }, [codigoDepartamento, codigoMunicipio])

  if (!codigoMunicipio) return null

  return <>{nombre ? nombre.toUpperCase() : codigoMunicipio}</>
}
